(function(){
const youth=new Set(['YXXXS','YXXS','Y2XS','YXS','YS','YM','YL','YXL','Y2XL','Y3XL','Y4XL','Y5XL']);
const adult=new Set(['XXXS','XXS','XS','S','M','L','XL','XXL','XXXL','XXXXL','XXXXXL','2XL','3XL','4XL','5XL','AXXXS','AXXS','AXS','AS','AM','AL','AXL','AXXL','AXXXL','AXXXXL','AXXXXXL','A2XL','A3XL','A4XL','A5XL','2AXL','3AXL','4AXL','5AXL']);
const confirmSizes=new Set(['L','XL','XXL','XXXL','XXXXL','XXXXXL','2XL','3XL','4XL','5XL','AL','AXL','AXXL','AXXXL','AXXXXL','AXXXXXL','A2XL','A3XL','A4XL','A5XL','2AXL','3AXL','4AXL','5AXL']);
function norm(v){return String(v||'').trim().toUpperCase()}
function decorate(root){
 root.querySelectorAll('[data-anton-size-picker]').forEach(p=>{
  p.querySelectorAll('[data-anton-size-value]').forEach(input=>{
   const field=input.parentElement && input.parentElement.parentElement;
   if(!field)return;
   field.querySelectorAll('.anton-size-group-label').forEach(x=>x.remove());
   const v=norm(input.value);
   let type='';
   if(youth.has(v))type='youth';
   else if(adult.has(v))type='adult';
   if(!type)return;
   const label=document.createElement('span');
   label.className='anton-size-group-label anton-size-group-label--'+type;
   label.textContent=type==='youth'?'YOUTH':'ADULT';
   field.prepend(label);
  });
 });
}
function getSelectedSizeForForm(form){
 const pf=form.closest('product-form');
 const sectionId=pf&&pf.getAttribute('section-id');
 if(!sectionId)return document.querySelector('[data-anton-size-picker] input:checked');
 const selector='product-variant-listener[section-id="'+sectionId+'"] [data-anton-size-picker] input:checked';
 return document.querySelector(selector);
}
function getFormForSizeInput(input){
 const listener=input.closest('product-variant-listener');
 const sectionId=listener&&listener.getAttribute('section-id');
 if(sectionId){
   const pf=document.querySelector('product-form[section-id="'+sectionId+'"]');
   const form=pf&&pf.querySelector('form[data-type="add-to-cart-form"]');
   if(form)return form;
 }
 return document.querySelector('form[data-type="add-to-cart-form"]');
}
function update(form){
 const box=form.querySelector('[data-anton-adult-confirmation]'); if(!box)return;
 const selected=getSelectedSizeForForm(form);
 const required=selected&&confirmSizes.has(norm(selected.value));
 box.hidden=!required;
 if(!required){
   const cb=box.querySelector('[data-anton-adult-checkbox]');
   if(cb)cb.checked=false;
   const err=box.querySelector('[data-anton-adult-error]');
   if(err)err.hidden=true;
 }
}
function init(root=document){decorate(root);root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(update)}
document.addEventListener('change',e=>{if(e.target.matches('[data-anton-size-value]')){const f=getFormForSizeInput(e.target);if(f)setTimeout(()=>update(f),0)}if(e.target.matches('[data-anton-adult-checkbox]')){const err=e.target.closest('[data-anton-adult-confirmation]').querySelector('[data-anton-adult-error]');if(e.target.checked&&err)err.hidden=true}});
document.addEventListener('submit',e=>{const f=e.target;if(!f.matches('form[data-type="add-to-cart-form"]'))return;const box=f.querySelector('[data-anton-adult-confirmation]');if(box&&!box.hidden&&!box.querySelector('[data-anton-adult-checkbox]').checked){e.preventDefault();e.stopImmediatePropagation();const err=box.querySelector('[data-anton-adult-error]');err.hidden=false;box.querySelector('[data-anton-adult-checkbox]').focus()}},true);
document.addEventListener('variantUpdate',()=>setTimeout(()=>init(),0));
document.addEventListener('shopify:section:load',()=>init());

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();